import { useMutation } from '@tanstack/react-query';
import type {
  AceitarConviteDto,
  ConvidarDto,
  ConviteCriado,
  ConviteLinha,
  ConvitePrevia,
  LoginResponse,
  NovoAcessoDto,
  UsuarioLinha,
  UsuariosResponse,
} from '@triade/contracts';
import { ApiError, requisitar } from '@/lib/api';
import { useQuery } from '@tanstack/react-query';
import { useConsulta, useMutacao } from './base';

const INVALIDAR = [['usuarios']];
/** A gestao de usuarios e do alcance de quem consulta (varias empresas): nao leva X-Empresa-Id (a API marca @SemEmpresa). */

/** GET /usuarios: usuarios, convites e o que quem consulta pode conceder (o teto e conferido na API). */
export function useUsuarios() {
  return useConsulta<UsuariosResponse>(['usuarios'], '/usuarios', { semEmpresa: true });
}

/** POST /usuarios/convites. Sem SMTP a resposta traz o `link` para copiar (so nesta resposta). */
export function useConvidar() {
  return useMutacao<ConviteCriado, ConvidarDto>({ metodo: 'POST', caminho: () => '/usuarios/convites', corpo: (v) => v, invalidar: INVALIDAR, semEmpresa: true });
}

export function useReenviarConvite() {
  return useMutacao<ConviteCriado, string>({ metodo: 'POST', caminho: (id) => `/usuarios/convites/${id}/reenviar`, corpo: () => ({}), invalidar: INVALIDAR, semEmpresa: true });
}

export function useRevogarConvite() {
  return useMutacao<ConviteLinha, string>({ metodo: 'DELETE', caminho: (id) => `/usuarios/convites/${id}`, invalidar: INVALIDAR, semEmpresa: true });
}

export function useAdicionarAcesso() {
  return useMutacao<UsuarioLinha, { usuarioId: string; acesso: NovoAcessoDto }>({
    metodo: 'POST',
    caminho: (v) => `/usuarios/${v.usuarioId}/acessos`,
    corpo: (v) => v.acesso,
    invalidar: INVALIDAR,
  });
}

export function useRemoverAcesso() {
  return useMutacao<UsuarioLinha, { usuarioId: string; acessoId: string }>({
    metodo: 'DELETE',
    caminho: (v) => `/usuarios/${v.usuarioId}/acessos/${v.acessoId}`,
    invalidar: INVALIDAR,
  });
}

export function useDesativarUsuario() {
  return useMutacao<UsuarioLinha, string>({ metodo: 'POST', caminho: (id) => `/usuarios/${id}/desativar`, corpo: () => ({}), invalidar: INVALIDAR, semEmpresa: true });
}

export function useReativarUsuario() {
  return useMutacao<UsuarioLinha, string>({ metodo: 'POST', caminho: (id) => `/usuarios/${id}/reativar`, corpo: () => ({}), invalidar: INVALIDAR, semEmpresa: true });
}

/** GET /convites/:token (publico): previa para a tela de aceite. 410 = convite invalido, usado ou vencido. */
export function usePreviaConvite(token: string | undefined) {
  return useQuery<ConvitePrevia, ApiError>({
    queryKey: ['convite', token ?? null],
    queryFn: () => requisitar<ConvitePrevia>(`/convites/${encodeURIComponent(token as string)}`, { autenticada: false }),
    enabled: Boolean(token),
    retry: false,
  });
}

/** POST /convites/aceitar (publico): define a senha, cria o usuario e devolve o token APP. */
export function useAceitarConvite() {
  return useMutation<LoginResponse, ApiError, AceitarConviteDto>({
    mutationFn: (dto) => requisitar<LoginResponse>('/convites/aceitar', { method: 'POST', body: dto, autenticada: false }),
  });
}
